
export default {
    props: {
        mode: {
            type: String,
            default: 'page',
        },
    },
    data () {
        return {
            username: this.$route.query.email || this.$route.query.username || null,
            dob: null,
        }
    },
    computed: {
        isPage () {
            return this.mode === 'page'
        },
        isModal () {
            return this.mode === 'modal'
        },
    },
    methods: {
        async resetPasswordStart () {
            const { error } = await this.$try('resetPasswordStart', ({ username: this.username, dob: this.dob }))
            if (!error) {
                if (this.isModal) {
                    this.$emit('close')
                    this.$alert({ message: 'If we have your email on file, we should have sent you a reset password email. Refresh this page after you\'ve logged in', variant: 'success' })
                } else {
                    this.$alert({ message: 'If we have your email on file, we should have sent you a reset password email', variant: 'success' })
                }
                this.username = null
            }
        }
    },
}

